import { Resource } from 'modules/core/base-resource';
import httpResource from 'modules/core/http-resource';

class TeamsResource extends Resource {
  constructor() {
    super('teams', httpResource);
  }

  public async uploadLogo(logo: File, teamId: number) {
    const formData = new FormData();

    formData.append('emblem', logo);

    return await this.child(`${teamId}/emblem`).post<any>(formData);
  }
}

const teamsResource = new TeamsResource();
export default teamsResource;
